import { render, staticRenderFns } from "./StoresSidebar.vue?vue&type=template&id=db260224&scoped=true&"
import script from "./StoresSidebar.vue?vue&type=script&lang=ts&"
export * from "./StoresSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StoresSidebar.vue?vue&type=style&index=0&id=db260224&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db260224",
  null
  
)

export default component.exports